import {Button, Stack, Typography} from "@mui/material";
import {useAtomValue} from "jotai/index";
import {LicenseRequestViewAtom} from "../../atoms";
import React from "react";
import AnimationSuccess from "../lottie-animations/AnimationSuccess";
import {updateLicenseState} from "../../utils/functions";
import {toast} from "react-toastify";
import {v4 as uuid} from "uuid";
import {doc, setDoc} from "firebase/firestore";
import {db} from "../../config/firebase";
import {Link} from "react-router-dom";
import {LicenseRequestType, LicenseType} from "../../utils/enums/LicenseRequestType";

export const LicenseRequestAccepted = () => {
  const licenseRequest = useAtomValue(LicenseRequestViewAtom);

  const from = licenseRequest?.firstName || licenseRequest?.lastName ? `${licenseRequest?.firstName} ${licenseRequest?.lastName}`?.trim() : licenseRequest?.email;

  const onUpdateState = async (state) => {
    if (state) {
      try {
        if (licenseRequest) {
          await updateLicenseState(licenseRequest?.uid, state)
        }
      } catch (e) {
        console.log(e);
        toast.error(e?.message || `Failed to ${state?.toLowerCase()?.replaceAll("_", " ")} license request`)
      }
    }
  }

  const onSentLicense = async () => {
    try {
      const requestUid = uuid();
      const dateCreated = new Date().getTime();
      await setDoc(
        doc(db, "license_requests", requestUid),
        {
          ...licenseRequest,
          uid: requestUid,
          email: licenseRequest?.recipientMail,
          recipientMail: licenseRequest?.email,
          state: LicenseRequestType.PENDING,
          type: LicenseType.SEND_LICENCE,
          createdAt: dateCreated,
          expirationDate: new Date(dateCreated + (7 * 24 * 60 * 60 * 1000)).getTime(),
        }
      )
      toast.success(`License sent to recipient`);
      await onUpdateState(LicenseRequestType.SENDED)
    } catch (error) {
      console.log(error);
      toast.error("Failed to sent license");
    }
  }

  return (
    <Stack direction={"column"} gap={2}>
      <Typography variant={"h2"} fontWeight={700} align={"center"} gutterBottom>License Request Acknowledged</Typography>
      <AnimationSuccess />
      <Typography fontWeight={400} maxWidth={"sm"} sx={{mx: "auto"}} className={"text-grey"} align={"center"}>
        You have accepted license request from {from}. Please create license and send to the client <Typography component={"b"} fontWeight={700}>{licenseRequest?.email}</Typography>.
      </Typography>

      <Stack direction={"row"} gap={2} fullWidth>
        <Button
          color={"secondary"} variant={"outlined"}
          sx={{flex: 1, borderRadius: 2}}
          component={Link}
          to={`/portfolio?licenseUid=${licenseRequest?.licenseUid}`}
        >
          Go To Portfolio
        </Button>
        <Button
          color={"secondary"} variant={"text"}
          className={"sign-button"}
          onClick={onSentLicense}
          sx={{flex: 1, borderRadius: 2}}
        >
          Send License
        </Button>
      </Stack>
    </Stack>
  )
}